var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "詳細情報", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("AirportMasterForm", {
              ref: "airportForm",
              attrs: {
                "label-width": "10em",
                formMode: "edit",
                "autocomplete-airport-code-set": _vm.autocompleteAirportCodeSet,
                "autocomplete-airport-name-set": _vm.autocompleteAirportNameSet
              },
              model: {
                value: _vm.airportFormModel,
                callback: function($$v) {
                  _vm.airportFormModel = $$v
                },
                expression: "airportFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("EditDialogFooter", { on: { update: _vm.clickUpdate } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }